<ng-container *transloco="let t; prefix: 'comingSoon'">
  <!-- HEADER -->
  <div class="header-wrapper">
    <page-header
      [title]="t('title')"
      [icon]="['fas', 'home']"
      hasClose="true"
      (pageClose)="onCancel()"
      shadowOnScroll
    ></page-header>
    <page-description>
      <p>
        {{ t('description') }}
      </p>
    </page-description>
  </div>

  <!-- CONTENT -->
  <div class="content-wrapper push-footer-down">
    <form #formHandle="ngForm" [formGroup]="comingSoonForm" (ngSubmit)="onSubmit()">
      <!-- LEAVE US A NOTE SECTION -->
      <section-header
        [valid]="comingSoonForm.controls['note']?.valid"
        [touched]="comingSoonForm.controls['note']?.touched"
        >{{ t('note') }}</section-header
        >
        <section-content>
          <div class="form-field-container" formGroupName="note">
            <mat-form-field class="width-50">
              <input matInput [placeholder]="t('name')" formControlName="name" />
              @if (note.controls['name'].errors) {
                <mat-error>{{ t('invalidNameError') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="width-50">
              <input
                type="tel"
                matInput
                [placeholder]="t('phone')"
                formControlName="phone"
                [mask]="phoneFormat"
                />
              @if (note.controls['phone'].errors) {
                <mat-error>{{
                  t('invalidPhoneError')
                }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <textarea
                matInput
                [placeholder]="t('message')"
                formControlName="message"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="2"
                [cdkAutosizeMaxRows]="5"
              ></textarea>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="t('address')" formControlName="address" />
            </mat-form-field>
          </div>
        </section-content>

        <!-- PROPERTY TYPE SECTION -->
        <section-header
          [valid]="comingSoonForm.controls['propertyType'].valid"
          [touched]="comingSoonForm.controls['propertyType'].touched"
          >{{ t('propertyType') }}</section-header
          >
          <section-content>
            <mat-radio-group formControlName="propertyType">
              <mat-radio-button value="Residential">{{ t('residential') }}</mat-radio-button>
              <mat-radio-button value="Commercial">{{ t('commercial') }}</mat-radio-button>
            </mat-radio-group>
          </section-content>

          <!-- IMPROVEMENTS SECTION -->
          <section-header
            [valid]="comingSoonForm.controls['improvements']?.valid"
            [touched]="comingSoonForm.controls['improvements']?.touched"
            >{{ t('improvementsList') }}</section-header
            >
            <section-content>
              <select-bubbles
                formControlName="improvements"
                [items]="this.items"
                [multi]="true"
                [translate]="true"
              ></select-bubbles>
            </section-content>
          </form>
        </div>

        <!-- FOOTER -->
        <div class="footer-wrapper not-fixed shadow">
          <page-footer
            [primary]="{ label: t('submitBtn'), arrow: 'right' }"
            [primLoading]="isLoading$ | async"
            (primaryClicked)="formHandle.onSubmit()"
            [secondary]="{ label: t('cancelBtn'), arrow: 'left' }"
            (secondaryClicked)="onCancel()"
            [valid]="comingSoonForm.valid && comingSoonForm.touched"
          ></page-footer>
        </div>
      </ng-container>
